/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  NotModified,
  NotModified$inboundSchema,
} from "../components/notmodified.js";
import {
  UpdatePackageForm,
  UpdatePackageForm$Outbound,
  UpdatePackageForm$outboundSchema,
} from "../components/updatepackageform.js";
import {
  UpdatePackageResult,
  UpdatePackageResult$inboundSchema,
} from "../components/updatepackageresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type UpdatePackageSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdatePackageSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdatePackageSecurity = {
  option1?: UpdatePackageSecurityOption1 | undefined;
  option2?: UpdatePackageSecurityOption2 | undefined;
};

export type UpdatePackageRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updatePackageForm: UpdatePackageForm;
};

export type UpdatePackageResponse = UpdatePackageResult | NotModified;

/** @internal */
export type UpdatePackageSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdatePackageSecurityOption1$outboundSchema: z.ZodMiniType<
  UpdatePackageSecurityOption1$Outbound,
  UpdatePackageSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function updatePackageSecurityOption1ToJSON(
  updatePackageSecurityOption1: UpdatePackageSecurityOption1,
): string {
  return JSON.stringify(
    UpdatePackageSecurityOption1$outboundSchema.parse(
      updatePackageSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdatePackageSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdatePackageSecurityOption2$outboundSchema: z.ZodMiniType<
  UpdatePackageSecurityOption2$Outbound,
  UpdatePackageSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updatePackageSecurityOption2ToJSON(
  updatePackageSecurityOption2: UpdatePackageSecurityOption2,
): string {
  return JSON.stringify(
    UpdatePackageSecurityOption2$outboundSchema.parse(
      updatePackageSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdatePackageSecurity$Outbound = {
  Option1?: UpdatePackageSecurityOption1$Outbound | undefined;
  Option2?: UpdatePackageSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdatePackageSecurity$outboundSchema: z.ZodMiniType<
  UpdatePackageSecurity$Outbound,
  UpdatePackageSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdatePackageSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdatePackageSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updatePackageSecurityToJSON(
  updatePackageSecurity: UpdatePackageSecurity,
): string {
  return JSON.stringify(
    UpdatePackageSecurity$outboundSchema.parse(updatePackageSecurity),
  );
}

/** @internal */
export type UpdatePackageRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdatePackageForm: UpdatePackageForm$Outbound;
};

/** @internal */
export const UpdatePackageRequest$outboundSchema: z.ZodMiniType<
  UpdatePackageRequest$Outbound,
  UpdatePackageRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updatePackageForm: UpdatePackageForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      updatePackageForm: "UpdatePackageForm",
    });
  }),
);

export function updatePackageRequestToJSON(
  updatePackageRequest: UpdatePackageRequest,
): string {
  return JSON.stringify(
    UpdatePackageRequest$outboundSchema.parse(updatePackageRequest),
  );
}

/** @internal */
export const UpdatePackageResponse$inboundSchema: z.ZodMiniType<
  UpdatePackageResponse,
  unknown
> = z.union([UpdatePackageResult$inboundSchema, NotModified$inboundSchema]);

export function updatePackageResponseFromJSON(
  jsonString: string,
): SafeParseResult<UpdatePackageResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdatePackageResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdatePackageResponse' from JSON`,
  );
}
